import React from "react";

const capabilities = [
  {
    title: "Modeling & Simulation",
    description: "Advanced tools for performance and safety simulation.",
    icon: "🛠️",
  },
  {
    title: "Digital Mock-ups",
    description: "Rapid prototyping and CNC machining for evaluation.",
    icon: "📐",
  },
  {
    title: "Sheet Metal Design",
    description: "Custom enclosures with materials like steel, aluminum.",
    icon: "🧰",
  },
  {
    title: "Design for Assembly",
    description: "Simplified designs to lower cost and boost efficiency.",
    icon: "⚙️",
  },
];

const MechanicalCapabilities = () => {
  return (
    <section className="bg-gray-100 py-16 px-4 sm:px-6 lg:px-12">
      <h2 className="text-3xl sm:text-4xl font-semibold text-center mb-16 text-gray-900">
        Mechanical Design & Simulation Capabilities
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-12 max-w-6xl mx-auto">
        {capabilities.map((cap, idx) => (
          <div
            key={idx}
            className="flex flex-row items-center gap-6"
          >
            {/* Icon */}
            <div className="flex items-center justify-center w-20 h-20 rounded-full bg-orange-500 text-white text-3xl">
              {cap.icon}
            </div>

            {/* Text */}
            <div className="max-w-md text-left">
              <h3 className="text-xl font-semibold mb-2 text-gray-800">{cap.title}</h3>
              <p className="text-gray-600 text-sm">{cap.description}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default MechanicalCapabilities;
